export enum JsType {
	ANIMATION_MIXER = 'animationMixer',
	ANIMATION_MIXER_UPDATE = 'animationMixerUpdate',
	ATTRIBUTE = 'attribute',
	CODE = 'code',
	CURSOR = 'cursor',
	FOR_LOOP = 'forLoop',
	GEOLOCATION_CURRENT_POSITION = 'geolocationCurrentPosition',
	GET_INSTANCE_ATTRIBUTE = 'getInstanceAttribute',
	GET_INSTANCE_PROPERTY = 'getInstanceProperty',
	GET_OBJECT_ATTRIBUTE = 'getObjectAttribute',
	GET_OBJECT_PROPERTY = 'getObjectProperty',
	GET_OBJECT_USER_DATA = 'getObjectUserData',
	GET_NODE = 'getNode',
	GET_PARAM = 'getParam',
	GET_POINT_ATTRIBUTE = 'getPointAttribute',
	GET_POINT_PROPERTY = 'getPointProperty',
	GET_PRIMITIVE_ATTRIBUTE = 'getPrimitiveAttribute',
	GLOBALS = 'globals',
	GLOBALS_AMBIENT_LIGHT = 'globalsAmbientLight',
	GLOBALS_AREA_LIGHT = 'globalsAreaLight',
	GLOBALS_DIRECTIONAL_LIGHT = 'globalsDirectionalLight',
	GLOBALS_HEMISPHERE_LIGHT = 'globalsHemisphereLight',
	GLOBALS_POINT_LIGHT = 'globalsPointLight',
	GLOBALS_SPOT_LIGHT = 'globalsSpotLight',
	IMPORT_ATTRIBUTE = 'importAttribute',
	KEYFRAMES = 'keyframes',
	ON_CHILD_ATTRIBUTE_UPDATE = 'onChildAttributeUpdate',
	ON_KEY = 'onKey',
	ON_KEYDOWN = 'onKeydown',
	ON_KEYPRESS = 'onKeypress',
	ON_KEYUP = 'onKeyup',
	ON_MAPBOX_CAMERA_MOVE = 'onMapboxCameraMove',
	ON_MAPBOX_CAMERA_MOVE_START = 'onMapboxCameraMoveStart',
	ON_MAPBOX_CAMERA_MOVE_END = 'onMapboxCameraMoveEnd',
	ON_OBJECT_ATTRIBUTE_UPDATE = 'onObjectAttributeUpdate',
	ON_OBJECT_BEFORE_DELETE = 'onObjectBeforeDelete',
	ON_OBJECT_CLICK = 'onObjectClick',
	ON_OBJECT_CLICK_GPU = 'onObjectClickGPU',
	ON_OBJECT_CONTEXT_MENU = 'onObjectContextMenu',
	ON_OBJECT_CONTEXT_MENU_GPU = 'onObjectContextMenuGPU',
	ON_OBJECT_DOUBLE_CLICK = 'onObjectDoubleClick',
	ON_OBJECT_DISPATCH_EVENT = 'onObjectDispatchEvent',
	ON_OBJECT_HOVER = 'onObjectHover',
	ON_OBJECT_HOVER_GPU = 'onObjectHoverGPU',
	ON_OBJECT_LONG_PRESS = 'onObjectLongPress',
	ON_OBJECT_LONG_PRESS_GPU = 'onObjectLongPressGPU',
	ON_OBJECT_MOUSE_CLICK = 'onObjectMouseClick',
	ON_OBJECT_POINTERDOWN = 'onObjectPointerdown',
	ON_OBJECT_POINTERDOWN_GPU = 'onObjectPointerdownGPU',
	ON_OBJECT_POINTERUP = 'onObjectPointerup',
	ON_OBJECT_POINTERUP_GPU = 'onObjectPointerupGPU',
	ON_OBJECT_SWIPE = 'onObjectSwipe',
	ON_OBJECT_SWIPE_GPU = 'onObjectSwipeGPU',
	ON_OBJECT_SWIPEDOWN = 'onObjectSwipedown',
	ON_OBJECT_SWIPELEFT = 'onObjectSwipeleft',
	ON_OBJECT_SWIPERIGHT = 'onObjectSwiperight',
	ON_OBJECT_SWIPEUP = 'onObjectSwipeup',
	ON_POINTERDOWN = 'onPointerdown',
	ON_POINTERUP = 'onPointerup',
	ON_SCENE_PAUSE = 'onScenePause',
	ON_SCENE_PLAY = 'onScenePlay',
	ON_SCENE_RESET = 'onSceneReset',
	ON_SCROLL = 'onScroll',
	ON_MANUAL_TRIGGER = 'onManualTrigger',
	ON_TICK = 'onTick',
	ON_PERFORMANCE_CHANGE = 'onPerformanceChange',
	ON_VIDEO_EVENT = 'onVideoEvent',
	ON_VIEWER_CONTROLS_EVENT = 'onViewerControlsEvent',
	ON_WEBXR_CONTROLLER_EVENT = 'onWebXRControllerEvent',
	OUTPUT = 'output',
	OUTPUT_AMBIENT_LIGHT = 'outputAmbientLight',
	OUTPUT_AREA_LIGHT = 'outputAreaLight',
	OUTPUT_DIRECTIONAL_LIGHT = 'outputDirectionalLight',
	OUTPUT_HEMISPHERE_LIGHT = 'outputHemisphereLight',
	OUTPUT_POINT_LIGHT = 'outputPointLight',
	OUTPUT_SPOT_LIGHT = 'outputSpotLight',
	PARAM = 'param',
	RAY_FROM_CURSOR = 'rayFromCursor',
	RAY_FROM_CAMERA = 'rayFromCamera',
	// SDF
	SDF_2D_BOX = 'SDF2DBox',
	SDF_2D_CIRCLE = 'SDF2DCircle',
	SDF_2D_CROSS = 'SDF2DCross',
	SDF_2D_HEART = 'SDF2DHeart',
	SDF_2D_ROUNDED_X = 'SDF2DRoundedX',
	SDF_BOX = 'SDFBox',
	SDF_ELONGATE = 'SDFElongate',
	SDF_ONION = 'SDFOnion',
	SDF_PLANE = 'SDFPlane',
	SDF_REVOLUTION = 'SDFRevolution',
	SDF_SPHERE = 'SDFSphere',
	SDF_TORUS = 'SDFTorus',
	SDF_TRANSFORM = 'SDFTransform',
	SDF_TUBE = 'SDFTube',
	// set
	SET_INSTANCE_ATTRIBUTE = 'setInstanceAttribute',
	SET_INSTANCE_LOOK_AT = 'setInstanceLookAt',
	SET_INSTANCE_POSITION = 'setInstancePosition',
	SET_INSTANCE_QUATERNION = 'setInstanceQuaternion',
	SET_INSTANCE_SCALE = 'setInstanceScale',
	SET_OBJECT_ATTRIBUTE = 'setObjectAttribute',
	SET_OBJECT_LOOK_AT = 'setObjectLookAt',
	SET_OBJECT_POSITION = 'setObjectPosition',
	SET_OBJECT_QUATERNION = 'setObjectQuaternion',
	SET_OBJECT_ROTATION = 'setObjectRotation',
	SET_OBJECT_SCALE = 'setObjectScale',
	SET_PARAM = 'setParam',
	SET_PHYSICS_RBD_POSITION = 'setPhysicsRBDPosition',
	SET_PLAYER_INPUT = 'setPlayerInput',
	SET_POINT_ATTRIBUTE = 'setPointAttribute',
	SET_POINT_POSITION = 'setPointPosition',
	SET_SOFT_BODY_CONSTRAINT_POSITION = 'setSoftBodyConstraintPosition',
	SET_SOFT_BODY_POSITION = 'setSoftBodyPosition',
	SET_SOFT_BODY_VELOCITY = 'setSoftBodyVelocity',
	SET_WFC_SOFT_CONSTRAINT = 'setWFCSoftConstraint',
	// TEXTURE_SDF = 'textureSDF',
	WFC_BUILD = 'WFCBuild',
}
